const globalTenants = {
    NATURIMAL: 'naturimal',
    LOS_JUNCOS: 'juncos'
};

export default globalTenants;
